<template>
  <v-app id="app" :dark="darkMode" :light="!darkMode">
    <v-content>
      <v-container fluid v-cloak>
        <AppMenu />
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Vue from "vue";
import store from "./store";
import AppMenu from "@/components/AppMenu.vue";

import "vuetify/dist/vuetify.min.css";
import "@/styles/theme.scss";
import "@/styles/stepper.scss";

import vSelect from "vue-select";
import Vuetify, {
  VApp,
  VNavigationDrawer,
  VCard,
  // VCalendar,
  VDatePicker,
  VIcon,
  // VInput,
  VTab,
  VToolbar
} from "vuetify/lib";
import { Ripple } from "vuetify/lib/directives";
import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
  theme: {
    primary: "#1b355d",
    secondary: "#00b1a9",
    accent: "#00b1a9",
    error: "#FF5252",
    light: "#c8daf7",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00"
  },
  components: {
    VApp,
    VNavigationDrawer,
    VCard,
    vSelect,
    // VCalendar,
    VDatePicker,
    VIcon,
    // VInput,
    VTab,
    VToolbar
  },
  iconfont: "md",
  directives: {
    Ripple
  }
});

export default {
  components: { AppMenu },
  computed: {
    darkMode: {
      get() {
        return store.state.darkMode;
      },
      set() {
        console.log("don't set darkmode from here");
      }
    }
  },
  data: () => ({
    store: store,
    error: false,
    loading: false
  })
};
</script>

<style lang="scss">
[v-cloak] > * {
  display: none;
}
[v-cloak]::before {
  content: "";
  display: block;
  position: absolute;
  width: 80px;
  height: 80px;
  background-size: cover;
  left: 50%;
  top: 50%;
}
</style>
